module.exports = __webpack_public_path__ + "img/SES_8293R.6630df26.jpg";